import { render, staticRenderFns } from "./AddEditSchool.vue?vue&type=template&id=2a76633e&"
import script from "./AddEditSchool.vue?vue&type=script&lang=js&"
export * from "./AddEditSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports